<template>
    <q-table
        ref="table"
        :data="available"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        @request="requestAvailable"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="id" :props="props">
                    {{ props.row.id }}
                </q-td>
                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="created_date" :props="props">
                    {{ fDate(props.row.created_date) }}
                </q-td>

                <q-td key="date_class" :props="props">
                    {{ fDate(props.row.date_class) }}
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    data() {
        return {
            pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: false,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'created_date',
                    required: true,
                    label: 'created_date',
                    align: 'left',
                    field: 'created_date',
                    sortable: false,
                },
                {
                    name: 'date_class',
                    required: true,
                    label: 'training_date',
                    align: 'left',
                    field: 'date_class',
                    sortable: false,
                }
            ],
            available: [],
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            selected_user: 'users/selected_user',
            num_rows: 'datatable/num_rows',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },
    methods: {
        requestAvailable({ pagination }) {
            this.loading = true
            this.pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination.rowsPerPage,
                "page": this.pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`admin_users/users/${this.selected_user}/get_user_live_class_available/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.pagination.rowsNumber = response.data.count

                this.available = response.data.results.map(result => result)
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination.rowsPerPage])
        },

        loadPagination() {
            this.pagination.rowsPerPage = this.num_rows
        },
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
      this.loadPagination()
      this.requestAvailable({ pagination: this.pagination })
	}
}
</script>

<style>

</style>
